import { render } from "./Ankete.vue?vue&type=template&id=9445e47a&scoped=true"
import script from "./Ankete.vue?vue&type=script&lang=js"
export * from "./Ankete.vue?vue&type=script&lang=js"

import "./Ankete.vue?vue&type=style&index=0&id=9445e47a&scoped=true&lang=css"
import "./Ankete.vue?vue&type=style&index=1&id=9445e47a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9445e47a"]])

export default __exports__